import Vuex from "vuex";
import ProgressStore from "./ProgressStore";
import UserStore from "./UserStore";
import Vue from "vue";
import NotificationStore from "./NotificationStore";
import QuestionsStore from "./QuestionsStore";
import FooterStore from "./FooterStore";
import DashboardStore from "./DashboardStore";

Vue.use(Vuex);
export default new Vuex.Store({
  modules: {
    footer: FooterStore,
    progress: ProgressStore,
    user: UserStore,
    dashboard: DashboardStore,
    notification: NotificationStore,
    questions: QuestionsStore
  }
});
